import { Component } from "excalibur";

export class EnemyComponent extends Component {}
